import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { Holding, TaxConsumption, TradeProposalBase, TradeProposalPack, } from "../types";
export const hypotheticalProposalUrl = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/hypothetical-proposal`
        : `https://middleware.uat.farther.com/investment/hypothetical-proposal`;
};
// RESPONSE BODY
export const HypotheticalProposal = TradeProposalBase.extend({
    validFrom: z.null(),
    expiresAt: z.null(),
    submittedAt: z.null(),
});
const HypotheticalProposalResponse = HypotheticalProposal.extend({
    postTradeDetails: Holding.array(),
    ytdTaxConsumption: TaxConsumption,
});
const HypotheticalProposalPack = TradeProposalPack.extend({
    proposals: HypotheticalProposalResponse.array(),
});
const SuccessFullResponse = z.object({
    data: z.object({
        proposalsWithTaxBudget: HypotheticalProposalPack,
        proposalsWithoutTaxBudget: HypotheticalProposalPack,
    }),
});
export const postHypotheticalProposal = async (requestBody, config) => {
    const parsedTaxBudget = {
        ...requestBody.taxBudget,
        year: requestBody.taxBudget.year.getFullYear().toString(),
        budgetAmount: requestBody.taxBudget.budgetAmount.toString(),
    };
    const resp = await axios.post(hypotheticalProposalUrl(), {
        ...requestBody,
        taxBudget: parsedTaxBudget,
    }, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
            version: "20250513",
            "Idempotency-key": `Create:HypotheticalProposal:${Date.now()}`, // Because this is similar to a dry-run, we don't need to worry about idempotency
        },
    });
    const decoded = SuccessFullResponse.safeParse(resp.data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = "[postHypotheticalProposal] returned unexpected data.";
        errorLog(postHypotheticalProposal.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=postHypotheticalProposalV2.js.map